/**
 * Client-side QA/test room detector. Mirrors the backend naming pattern so the
 * browse surfaces can hide throwaway test lobbies from real users (and surface
 * them under a dedicated 🧪 QA tab). A room is "QA" when its name starts with a
 * known test prefix (case-insensitive) or contains "regression".
 *
 * Keep this in sync with the server-side filter (RoomHub / DiscoveryService).
 */
const QA_PREFIXES = ['test', 'debug', 'call-smoke', 'webgl_test', 'smoke'];
const QA_WORD = /\bqa\b/i;

export function isQaRoom(name?: string): boolean {
  if (!name) return false;
  const n = name.trim().toLowerCase();
  if (!n) return false;
  if (QA_PREFIXES.some((p) => n.startsWith(p))) return true;
  if (QA_WORD.test(n)) return true;
  if (n.includes('regression')) return true;
  return false;
}
